import { render, staticRenderFns } from "./companyMember.vue?vue&type=template&id=28845ae4&scoped=true&"
import script from "./companyMember.vue?vue&type=script&lang=js&"
export * from "./companyMember.vue?vue&type=script&lang=js&"
import style0 from "./companyMember.vue?vue&type=style&index=0&id=28845ae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28845ae4",
  null
  
)

export default component.exports